import { randomBytes } from 'crypto';
import { NEXO_IV_LENGTH } from './enums';

export const nonce = () => randomBytes(NEXO_IV_LENGTH);
